import React from 'react';
import {IGlobalStorefrontSettings, IStorefrontSettings} from '../../models/Storefront';

import ToggleField from "../Common/ToggleField";
import RichTextField from "../Common/RichTextField";

interface IStorefrontSettingsFormProps {
    globalSettings?: IGlobalStorefrontSettings;
    settings: IStorefrontSettings;
    onChange: (settings: IStorefrontSettings) => void;
    onLoading?: (isLoading: boolean) => void;
}

const StorefrontTermsAndConditionsForm: React.FC<IStorefrontSettingsFormProps> = (props) => {
    
    return (
        <div>
            <ToggleField inline={true} label='Override Terms and Conditions' checked={props.settings.overrideTermsAndConditions} onChange={(e, c) => props.onChange({...props.settings, overrideTermsAndConditions: c})} />
            {props.settings.overrideTermsAndConditions &&
                <div>
                    <RichTextField label={'Checkout Terms and Conditions'} mode={"markdown"} value={props.settings.termsAndConditions} toolTip={'Markdown allowed'} onChange={( c) => props.onChange({...props.settings, termsAndConditions: c})}></RichTextField>
                </div>
            }
        </div>
    );
}

export default StorefrontTermsAndConditionsForm;